import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Cell,
} from "recharts";
import { TrendingUp, MapPin, Layers } from "lucide-react";

const data = [
  { name: "Year 1", mid: 1.0, label: "$500K \u2013 $1.5M" },
  { name: "Year 2", mid: 3.0, label: "$2M \u2013 $4M" },
  { name: "Year 3", mid: 7.5, label: "$5M \u2013 $10M+" },
];

const CustomXTick = ({ x, y, payload }) => {
  const item = data.find((d) => d.name === payload.value);
  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={14}
        textAnchor="middle"
        fill="#64748b"
        fontSize={13}
        fontFamily="Satoshi, sans-serif"
      >
        {payload.value}
      </text>
      <text
        x={0}
        y={0}
        dy={30}
        textAnchor="middle"
        fill="#0f172a"
        fontSize={13}
        fontWeight={700}
        fontFamily="Cabinet Grotesk, sans-serif"
      >
        {item?.label}
      </text>
    </g>
  );
};

export default function FinancialsSlide() {
  return (
    <div
      className="h-full w-full flex flex-col p-7 sm:p-10 lg:p-12"
      data-testid="slide-financials-content"
    >
      <span className="text-sm font-bold tracking-[0.2em] uppercase text-blue-600 mb-2 font-body">
        FINANCIAL PROJECTIONS
      </span>
      <h1 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-black tracking-tighter text-slate-900 mb-6 leading-tight">
        Scalable revenue with strong expansion potential
      </h1>

      <div className="h-[240px] md:flex-1 md:h-auto min-h-0">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            margin={{ top: 20, right: 40, left: 40, bottom: 20 }}
            barCategoryGap="30%"
          >
            <XAxis
              dataKey="name"
              axisLine={false}
              tickLine={false}
              tick={<CustomXTick />}
              height={55}
            />
            <YAxis hide />
            <Bar dataKey="mid" radius={[6, 6, 0, 0]} maxBarSize={120}>
              {data.map((entry, i) => (
                <Cell
                  key={i}
                  fill={i === 2 ? "#2563EB" : i === 1 ? "#60A5FA" : "#93C5FD"}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="flex flex-wrap gap-2 md:gap-6 sm:gap-8 mt-3 md:mt-4 justify-center">
        {[
          { icon: TrendingUp, text: "NY penetration + repeat usage" },
          { icon: MapPin, text: "State-by-state expansion" },
          { icon: Layers, text: "High-margin software model" },
        ].map((item, i) => (
          <div key={i} className="flex items-center gap-1.5">
            <item.icon className="h-3 w-3 text-slate-400" />
            <span className="text-sm text-slate-500 font-body">
              {item.text}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
